<script>
	// import applePayMark from '../../assets/svg/logos/apple-pay-mark.svg';
	// import gPayLogo from '../../assets/svg/logos/g-pay-logo.svg';
	// import mastercardLogo from '../../assets/svg/logos/mastercard-logo.svg';
	// import visaLogo from '../../assets/svg/logos/visa-logo.svg';
	import Icon from '../Icon/Icon.svelte';
	import IconWrapper from '../IconWrapper/IconWrapper.svelte';
	import LinksList from '../LinksList/LinksList.svelte';

	export let facebookUrl = '';
	export let instagramUrl = '';
	export let linkedinUrl = '';
	/** @type {{ title: string; menu: { Default: string }; iconName: string; label: { Default: string }; }[]}[]} */
	export let menusList = [];
</script>

<footer>
	{#if menusList.length}
		<nav>
			{#each menusList as { title, menu }}
				{#if menu?.items?.length}
					<LinksList title={title.Default} let:LinksListItem>
						{#each menu.items as { label, href }}
							<LinksListItem href={href.Default} kind="ghost" size="xs">
								{label.Default}
							</LinksListItem>
						{/each}
					</LinksList>
				{/if}
			{/each}
		</nav>
	{/if}

	<nav class="social-nav">
		<menu>
			<li>
				<IconWrapper href={facebookUrl} target="_blank" title="facebook">
					<Icon fill name="facebook" --stroke="none" />
				</IconWrapper>
			</li>

			<li>
				<IconWrapper href={instagramUrl} target="_blank" title="instagram">
					<Icon fill name="instagram" --stroke="none" />
				</IconWrapper>
			</li>

			<li>
				<IconWrapper href={linkedinUrl} target="_blank" title="linkedin">
					<Icon fill name="linkedin" --stroke="none" />
				</IconWrapper>
			</li>
		</menu>
	</nav>

	<div class="copyright">
		© {new Date().getFullYear()} Resider sp z o. o.
	</div>

	<!-- <section class="accepted-payment-methods">
		<img class="mastercard" src={mastercardLogo} alt="Mastercard" loading="lazy" decoding="async" />
		<img class="visa" src={visaLogo} alt="Visa" loading="lazy" decoding="async" />
		<img class="apple-pay" src={applePayMark} alt="Apple Pay" loading="lazy" decoding="async" />
		<img class="g-pay" src={gPayLogo} alt="G Pay" loading="lazy" decoding="async" />
	</section> -->
</footer>

<style>footer{display:grid;grid-gap:3rem;gap:3rem;padding:5rem .5rem 3rem}@media (min-width:767.02px){footer{gap:4rem;padding:8rem .75rem 4rem}}nav{display:grid;grid-gap:3rem;gap:3rem}@media (min-width:767.02px){nav{grid-template-columns:repeat(auto-fit,minmax(18rem,auto));margin:auto;max-width:88rem}}.social-nav menu{display:flex;justify-content:center;gap:2rem}.social-nav li{list-style:none}.copyright{text-align:center}</style>
